<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><a id="page_xi"></a><b><span class="small">IMAGES FROM THE UNDERWORLD</span></b><a id="page_xii"></a><a id="page_1"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292756489_08_htit1.vue?487838b6